import { Component, QueryList, ViewChildren, ElementRef, Output, EventEmitter } from '@angular/core';
import { NgFor } from '@angular/common';

@Component({
  selector: 'app-codeinput',
  standalone: true,
  imports: [NgFor],
  templateUrl: './codeinput.component.html',
  styleUrl: './codeinput.component.css'
})
export class CodeinputComponent {
  code = Array(6).fill('');

  @ViewChildren('codeInput') inputs!: QueryList<ElementRef<HTMLInputElement>>;

  @Output() codeInputComplete = new EventEmitter<string>();

  trackByIndex(index: number) {
    return index;
  }

  ngAfterViewInit() {
    // Focus the first input after view initializes
    setTimeout(() => {
      this.inputs.first?.nativeElement.focus();
    });
  }

  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;

    const value = input.value.replace(/\D/g, '').slice(0, 1);
    input.value = value;
    this.code[index] = value;

    if (value && index < this.code.length - 1) {
      this.inputs.get(index + 1)?.nativeElement.focus();
    }

    if (this.code.every(v => v !== '')) {
      this.codeInputComplete.emit(this.code.join(''));
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace') {
      const input = event.target as HTMLInputElement;

      if (!input.value && index > 0) {
        const prev = this.inputs.get(index - 1)!.nativeElement;
        prev.focus();
        prev.value = '';
        this.code[index - 1] = '';
      }
    }
  }

}
